(function ($) {
  'use strict';

  /**
   * Detect if an element is scrollable
   */

  $.fn.isScrollable = function () {
    return this[0].scrollWidth > this[0].clientWidth
      || this[0].scrollHeight > this[0].clientHeight;
  };

})(jQuery);
